// Sistema de puntuación separado y verificable.
// Registra cada evento de puntuación en un log con firma (hash) para que en el futuro
// un servidor pueda validar la partida de forma justa en rankings/competencias.

export class ScoreSystem {
  constructor() {
    this.events = [];
    this.total = 0;
    this.startedAt = Date.now();
  }

  record(type, value, meta = {}) {
    const event = { type, value, t: Date.now() - this.startedAt, meta };
    this.events.push(event);
    this.total += value;
    return event;
  }

  get score() {
    return this.total;
  }

  // Firma determinista (FNV-1a) de la secuencia de eventos de puntuación.
  signature() {
    let h = 2166136261;
    const s = JSON.stringify(this.events.map((e) => [e.type, e.value]));
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0).toString(16);
  }

  toRunPayload() {
    return {
      score: this.total,
      events: this.events,
      signature: this.signature(),
    };
  }
}
